import { ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';
import { IAccountingBasisDTO, ICurrencyDTO } from '@modeso/types__aumico-lib-settings-be';

export interface IGeneralInformationOutput {
    company: ICompanyNameIdLegalFormDTO | null;
    balanceSheetDate: string | null;
    balancePreviousYearDate: string | null;
    incomeCurrentYearFromDate: string | null;
    incomeCurrentYearToDate: string | null;
    incomePreviousYearFromDate: string | null;
    incomePreviousYearToDate: string | null;
    currency: ICurrencyDTO | null;
    accountingBasis: IAccountingBasisDTO | null;
    noPreviousData: boolean | null;
    isAutoFillFromPreviousAnnualReportEnabled: boolean | null;
    isPreviousDataTakenFromPreviousAnnualReport: boolean | null;
    locale: string;
}
